import React from 'react'
import { useMutation } from 'react-query'
import hooks from '../../../hooks'

const useReflectionPromptMutation = ({
    reflectionPrompt: importedReflectionPrompt = {},
    onSuccess = () => {}
}) => {
    const [reflectionPrompt, setReflectionPrompt] = React.useState(importedReflectionPrompt)
    const cacheKeys = hooks.useCacheKeys()
    const { clearCache } = hooks.useCache({ key: cacheKeys.REFLECTION_PROMPTS, onReload: onSuccess })
    const { api, endpoints, url } = hooks.useApi()
    const { toastSuccess, toastError } = hooks.useToasts({ onSuccess: clearCache })

    const {
        id,
        name,
        description,
        startDate,
        endDate
    } = reflectionPrompt

    const [ create, { isLoading: isCreating }] = useMutation(
        () => api.post(endpoints.reflectionPrompts, {
            name,
            description,
            startDate,
            endDate
        }),
        {
            onSuccess: () => toastSuccess('Reflection prompt created!'),
            onError: toastError
        }
    )

    const [ update, { isLoading: isUpdating }] = useMutation(
        () => api.put(url(endpoints.reflectionPrompt, { promptId: id }), {
            name,
            description,
            startDate,
            endDate
        }),
        {
            onSuccess: () => toastSuccess('Reflection prompt saved!')
        }
    )

    const saveReflectionPrompt = React.useCallback(() => {
        if (id) {
            update()
        } else {
            create()
        }
    }, [id, create, update])

    return {
        isSavingReflectionPrompt: isCreating || isUpdating,
        reflectionPrompt,
        setReflectionPrompt,
        saveReflectionPrompt
    }
}

export default useReflectionPromptMutation
